import ContactPage from 'src/components/page/contact'
export default ContactPage